import React, { useEffect, useState } from 'react';
import { Plugins, Capacitor } from '@capacitor/core';
//import { View, Button, Alert } from 'react-native';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { App } from '@capacitor/app';
import axios from 'axios';
import Api from "../Api/Api.json";
import JsPlugin from '../JsPlugin';

const LOCAL_VERSION = '1.0.0'; // Local version of the APK

export async function InstallApk () {
    //1. call api, 2. check response 3. download apk
    //4. install apk
    checkRemoteAPK();
};
    const checkRemoteAPK = async () => {
        var local_apk_version=localStorage.getItem('apk_version') 
        if(local_apk_version===null){
            local_apk_version='1.0.0'
        }
        const headers = { headers: { "Content-Type": "application/json" } }
        const url = Api.PATIENT_API;
        const requestData = {
          task: 'checkAPKUpdate',
          client_version_string: local_apk_version,
        };
        axios.post(url,requestData,headers)
        .then(response=>{
          console.log(response.data)
            if (response.data.version==='latest'){
                console.log('apk updated');
            }
            else{
                console.log('installing apk');
                handleInstallApk(response.data);
            }
        })
        .catch(error=>{
          console.log(error)
        });
    };


  const handleInstallApk = async (resp) => {
    /*try {
        JsPlugin.updateApk({ url: resp.url,version:resp.version }).then(result => {
            //setText("installing");
        });

        //localStorage.setItem('apk_version', JSON.stringify(resp.version));
        console.log('APK installed successfully');
      } catch (error) {
        console.error('Error downloading and installing APK:', error);
      }*/
  };


